/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useRef, useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { getClasses } from 'wfui-digital-core/es/lib';
import useKeyEvent from 'wfui-digital-core/es/useKeyEvent';
import FocusTrap from 'wfui-digital-core/es/FocusTrap';
import StickyFooterContext from '../context/StickyFooterContext';
import SecondaryMenu from '../secondary-menu/SecondaryMenu';
import MenuContent from './menu-content/MenuContent';
import styles from './Menu.less';

var getTranslateY = function getTranslateY(_ref) {
  var menuOpen = _ref.menuOpen,
      menuClosing = _ref.menuClosing,
      windowHeight = _ref.windowHeight;

  if (menuClosing) {
    return 0;
  }

  return menuOpen ? -windowHeight : 0;
};

var Menu = function Menu() {
  var menuRef = useRef();
  var modalRootRef = useRef(document.getElementById('sys-modal-root'));
  var containerRef = useRef(document.createElement('div'));

  var _useContext = useContext(StickyFooterContext),
      menuOpen = _useContext.menuOpen,
      menuClosing = _useContext.menuClosing,
      headingId = _useContext.headingId,
      closeMenu = _useContext.closeMenu,
      windowHeight = _useContext.windowHeight,
      footerHeight = _useContext.footerHeight;

  useEffect(function () {
    var modalRoot = modalRootRef.current;
    var container = containerRef.current;
    modalRoot.appendChild(container);
    return function () {
      return modalRoot.removeChild(container);
    };
  }, []);
  useKeyEvent({
    keyMap: {
      'Escape': closeMenu
    }
  });
  var translateY = getTranslateY({
    menuOpen: menuOpen,
    menuClosing: menuClosing,
    windowHeight: windowHeight
  });
  var classes = ['menu', menuOpen && 'open', menuClosing && 'closing'];
  var classNames = getClasses({
    styles: styles,
    classes: classes
  });
  var focusTrapOptions = {
    clickOutsideDeactivates: true,
    skipFocusFirst: true
  };
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
    role: "dialog",
    "aria-labelledby": headingId,
    ref: menuRef,
    className: classNames,
    style: {
      top: windowHeight,
      height: windowHeight - footerHeight,
      transform: "translate3d(0, ".concat(translateY, "px, 0)"),
      transition: 'transform .5s'
    }
  }, menuOpen && /*#__PURE__*/React.createElement(FocusTrap, {
    focusTrapOptions: focusTrapOptions
  }, /*#__PURE__*/React.createElement(MenuContent, null), /*#__PURE__*/React.createElement(SecondaryMenu, null))), containerRef.current);
};

export default Menu;